import React from "react";
import { Dialog, KeyValueList } from "@sscs/ui";
import { buildRlPurl, formatCount, humanReadableBytes } from "@sscs/utils";
import { ImportableVersion } from "Modules/importableVersions";
import { ExternalPackageSummary } from "../../types";

type OverviewProps = {
  catalogName: string;
  externalPackage: ExternalPackageSummary;
  projectName: string;
  packageName: string;
  selectedVersions: ImportableVersion[];
  totalVersions: number;
  autoSync: boolean;
  notifyOnCompletion: boolean;
  remainingCapacity: number;
  autoApprovalEnabled: boolean;
};

const Overview = ({
  catalogName,
  externalPackage,
  projectName,
  packageName,
  selectedVersions,
  totalVersions,
  autoSync,
  notifyOnCompletion,
  remainingCapacity,
  autoApprovalEnabled,
}: OverviewProps): React.JSX.Element => {
  const selectedBytes = selectedVersions.reduce(
    (sum, item) => sum + item.size,
    0,
  );

  return (
    <>
      <KeyValueList
        list={[
          "Importing from",
          {
            Catalog: catalogName,
            Software: externalPackage.name,
            Publisher: externalPackage.publisher,
          },
          "Importing to",
          {
            PURL: <code>{buildRlPurl(projectName, packageName)}</code>,
            "Automatically sync new versions": autoSync ? "Yes" : "No",
            "Notify when analysis completes": notifyOnCompletion ? "Yes" : "No",
          },
          "Versions",
          {
            Selected: `${formatCount(selectedVersions.length, "version")} of ${totalVersions}`,
            Versions: selectedVersions.map((item) => item.version).join(", "),
            "Total size": humanReadableBytes(selectedBytes, 2),
            "Remaining capacity after import": humanReadableBytes(
              remainingCapacity - selectedBytes,
              2,
            ),
          },
        ]}
      />
      {!autoApprovalEnabled && (
        <Dialog.Banner type="warning" title="Auto approval is disabled">
          At least one version must be approved before the package appears in
          the catalog.
        </Dialog.Banner>
      )}
    </>
  );
};

export default Overview;
